<template>
    <div class="ceshi-box">
        <el-button type="primary" @click="vuePrint">打印</el-button>
        <el-button type="danger" @click="printTicket">打印小票</el-button>
        <div id="print">
            <div class="title">消费明细</div>
            <div class="head">
                <li>桌号：10001</li>
                <li>单据号：20190101010223</li>
            </div>
        </div>

        <section ref="print">
            打印内容
            <div class="no-print">不要打印我</div>
        </section>
        <section ref="vuePrint">
            <ticket-tpl></ticket-tpl>
        </section>
    </div>
</template>

<script>
    import printJS from 'print-js';
    import TicketTpl from "@/model/Cash/TicketTpl";
    import Vue from "vue";
    import Print from "@/js/print";

    Vue.use(Print);
    export default {
        name: "Ceshi",
        components: {TicketTpl},
        methods: {
            onPrint: function () {
                printJS({
                    printable: 'print',
                    type: 'html',
                    scanStyles: false,
                    css: '/style/PostTicket.css',
                });
            },
            //打印小票
            printTicket: function () {
                printJS({
                    printable: 'ticket',
                    type: 'html',
                    scanStyles: false,
                    css: '/style/PostTicket.css',
                });
                this.close();
            },
            vuePrint: function () {
                this.$print(this.$refs.vuePrint);
            }
        }
    }
</script>

<style scoped>
    #print{
        display: none;
    }
</style>

<style>
    @media print {
        html {
            /*font-size: 26.48mm;*/
            /*font-size: 100px;*/
        }

        body {
            zoom: 0.75;
            /*-webkit-font-smoothing: antialiased;*/
        }

        .ticket-box {
            padding: 0 5px 0 0;
            text-align: left;
            font-family: SimSun, SimHei, "Microsoft YaHei";
            line-height: 24px;
        }

        .ticket-box > .title {
            height: 45px;
            line-height: 45px;
            margin-top: 10px;
            font-size: 16px;
            color: #000000;
            text-align: center;
        }

        .ticket-box .divider {
            position: relative;
            margin: 20px 0;
            display: block;
            height: 1px;
            width: 100%;
            border-bottom: 1px solid #000000;
        }

        .ticket-box .divider .divider-text {
            position: absolute;
            left: 50%;
            -webkit-transform: translateX(-50%) translateY(-50%);
            transform: translateX(-50%) translateY(-50%);
            background-color: #FFF;
            padding: 0 20px;
            color: #000000;
            font-weight: 500;
            /*font-size: 14px;*/
        }

        .ticket-box .info-box {
            color: #000000;
            padding-top: 10px;
        }

        .ticket-box .info-box > .row {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            width: 100%;
        }

        .info-box > .row > .left {
            width: 100px;
        }

        .info-box > .row > .right {
            flex: 1;
            text-align: right;
        }

        .product-list > .item {
            border-bottom: 1px solid #000000;
            font-weight: normal;
            color: #000000;
            display: flex;
            flex-flow: row nowrap;
            padding: 10px 0;
        }

        .product-list > .item > .index {
            width: 20px;
        }

        .product-list > .item > .product-box {
            flex: 1;
        }

        .product-box > .row {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
        }

        .product-box > .row > .left {
            width: 100px;
        }

        .product-box > .row > .right {
            flex: 1;
            text-align: right;
        }

        .foot {
            margin-top: 20px;
            font-weight: normal;
            color: #000000;
        }

        .foot > p {
            text-align: center;
        }
    }

</style>
